import filterTabs from "./filter-tabs";
import initializeFaqUrlHash from "./faq-urlHash";
import { checkUrlForCategory } from "../../07-libs/categoryUrlHash.js";
import faqPaginationScroll from "./faq.pagination-scroll.js";

function initializeFaq() {
  // Get the faq elements or return if there are none
  const faqElements = document.querySelectorAll(".tx-goldgas-faq");
  if (!faqElements.length) return;

  // Initialize the filter tabs for each faq element
  faqElements.forEach(el => {
    // filterTabs takes care of the search, pagination and category-selection
    filterTabs(el);
    // Fire the workaround for the initial selected category
    initialTabWorkaround(el);
  })

  /**
   * Workaround for the initial selected category.
   * Since filterTabs has some problems with the initial selected category, if
   * it is not the first global one, we have to do some workarounds.
   *
   * @param {HTMLElement} faq
   * @return {void}
   */
  function initialTabWorkaround(faq) {
    // Get the category buttons or exit
    const categoryButtons = faq.querySelectorAll(".filter-tabs__item");
    if (!categoryButtons.length) return;
    // Exit if the url does contain a valid category, because then the
    // initializeFaqUrlHash function will take care of the initial category
    if (checkUrlForCategory(categoryButtons)) return;
    // Get the initially active category or exit
    const active = faq.querySelector(".filter-tabs__item--active");
    if (!active) return;
    // Remove the active class or the filterTabs function will skip everything,
    // because it thinks the category is already active
    active.classList.remove("filter-tabs__item--active");
    // Fire the click event on the category to make it active again
    active.click();
  }

  // Initialize the url hash for each faq element.
  // This is done after the workaround to keep the url clean. Otherwise the
  // workaround would add the category to the url.
  initializeFaqUrlHash();

  // Initialize the pagination scroll for each faq element
  faqPaginationScroll();
}

export default initializeFaq;
